// Función global para sanitizar inputs de texto
// Elimina scripts, etiquetas HTML y espacios innecesarios
// Puedes expandirla según tus necesidades

export function sanitizeInput(value) {
  if (typeof value !== 'string') return value;
  // Elimina etiquetas HTML
  let sanitized = value.replace(/<[^>]*>?/gm, '');
  // Elimina espacios al inicio y final
  sanitized = sanitized.trim();
  // Opcional: elimina scripts embebidos
  sanitized = sanitized.replace(/<script.*?>.*?<\/script>/gi, '');
  // Opcional: elimina caracteres peligrosos
  sanitized = sanitized.replace(/[\"'`;]/g, '');
  return sanitized;
}

// Para inputs numéricos, puedes usar una función similar:
export function sanitizeNumber(value) {
  const num = Number(value);
  return isNaN(num) ? 0 : num;
}

// Para inputs de teléfono (mantiene como string solo con dígitos)
export function sanitizePhoneNumber(value) {
  if (typeof value !== 'string') return '';
  // Solo permite dígitos y elimina todo lo demás
  return value.replace(/\D/g, '');
}
